export enum ColumnTypes {
    USER = 'User',
    REVIEWER = 'Reviewer',
    APPROVER = 'Approver',
    ADMIN = 'Admin',
}

export const ColumnWidth = {
    [ColumnTypes.USER]: '5rem',
    [ColumnTypes.REVIEWER]: '3rem',
    [ColumnTypes.APPROVER]: '3rem',
    [ColumnTypes.ADMIN]: '3rem',
};

export enum FamilyColumnTypes {
    FAMILY = 'Family',
    CREATION_DATE = 'Creation Date',
    AUTHOR = 'Author',
}

export const FamilyColumnWidth = {
    [FamilyColumnTypes.FAMILY]: '5rem',
    [FamilyColumnTypes.CREATION_DATE]: '3rem',
    [FamilyColumnTypes.AUTHOR]: '3rem',
};
